<template>
  <div>
    <div class="btn-boxes">
      <div v-if="CheckAuthorizationOfRouter('Sales')" class="cursor-pointer card-bg" icon-pack="feather" @click="salesPopup()"><feather-icon icon="ShoppingBagIcon" /><span>Satış</span></div>
      <div v-if="CheckAuthorizationOfRouter('Purchase')" class="cursor-pointer card-bg" icon-pack="feather" @click="purchasePopup()"><feather-icon icon="ShoppingCartIcon" /> <span>Satın Alma</span></div>
      <div v-if="CheckAuthorizationOfRouter('Account')" class="cursor-pointer card-bg" icon-pack="feather" @click="accountPopup()"><feather-icon icon="CrosshairIcon" /> <span>Muhasebe</span></div>
      <div v-if="CheckAuthorizationOfRouter('Crm')" class="cursor-pointer card-bg" icon-pack="feather" @click="crmPopup()"><feather-icon icon="UsersIcon" /> <span>CRM</span></div>
      <div v-if="CheckAuthorizationOfRouter('IncomeExpense')" class="cursor-pointer card-bg" icon-pack="feather" @click="expensePopup()"><feather-icon icon="CodesandboxIcon" /> <span>Gelir Gider</span></div>
      <div v-if="CheckAuthorizationOfRouter('Warehouse')" class="cursor-pointer card-bg" icon-pack="feather" @click="warehousePopup()"><feather-icon icon="PackageIcon" /> <span>Depo</span></div>
      <div v-if="CheckAuthorizationOfRouter('TechnicAndGarage')" class="cursor-pointer card-bg" icon-pack="feather" @click="technicPopup()"><feather-icon icon="CpuIcon" /> <span>Teknik Servis, Garaj</span></div>
      <div v-if="CheckAuthorizationOfRouter('Ticket')" class="cursor-pointer card-bg" icon-pack="feather" @click="ticketPopup()"><feather-icon icon="HelpCircleIcon" /> <span>Destek Yönetimi</span></div>
      <div v-if="CheckAuthorizationOfRouter('Project')" class="cursor-pointer card-bg" icon-pack="feather" @click="projectPopup()"><feather-icon icon="SlackIcon" /> <span>Projeler</span></div>
      <div v-if="CheckAuthorizationOfRouter('HumanResource')" class="cursor-pointer card-bg" icon-pack="feather" @click="humanResourcePopup()"><feather-icon icon="UserIcon" /> <span>Yönetim-İnsan Kaynakları</span></div>
      <div v-if="CheckAuthorizationOfRouter('ParametricScreens') && this.$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null" class="cursor-pointer card-bg" icon-pack="feather" @click="parametricPopup()">
        <feather-icon icon="TabletIcon" /> <span>Parametrik Ekranlar</span>
      </div>
      <div v-if="CheckAuthorizationOfRouter('Arge')" class="cursor-pointer card-bg" @click="argePopup()"><i style="font-size: 50px;" class="material-icons-outlined">lightbulb_circle</i> <span>Arge</span></div>
      <div v-if="CheckAuthorizationOfRouter('AutomaticOperation')" class="cursor-pointer card-bg" @click="automaticPopup()"><i style="font-size: 50px;" class="material-icons-outlined">touch_app</i> <span>Otomatik İşlemler</span></div>
      <div v-if="CheckAuthorizationOfRouter('Reports')" class="cursor-pointer card-bg" icon-pack="feather" @click="reportsPopup()"><feather-icon icon="ClipboardIcon" /> <span>Raporlama</span></div>
      <div v-if="CheckAuthorizationOfRouter('Inventory')" class="cursor-pointer card-bg" icon-pack="feather" @click="inventoryStockMenu = true"><feather-icon icon="ScissorsIcon" /> <span>Zimmet & Demirbaş İşlemleri</span></div>
      <div v-if="CheckAuthorizationOfRouter('x')" class="cursor-pointer card-bg" @click="productionPopup()"><i style="font-size: 50px;" class="material-icons-outlined">extension</i> <span>Üretim</span></div>
    </div>

    <div class="btn-box-menus">
      <!-- Satis -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Sales')" :vs-buttons-hidden="true" vs-title="Nitro Satış" vs-button-cancel="border" :vs-active.sync="sales">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('Sales')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/Sales')">
            <feather-icon icon="CreditCardIcon" class="mb-3" />
            <b>Satış İşlemleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('x')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/SubscriptionSystem')">
            <feather-icon icon="RefreshCcwIcon" class="mb-3" />
            <b>Abonelikler</b>
          </div>
        </div>
      </vs-prompt>

      <!-- Satin Alma -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Purchase')" :vs-buttons-hidden="true" vs-title="Satın Alma" vs-button-cancel="border" :vs-active.sync="purchase">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('ProductAndStockList')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/Purchase')">
            <feather-icon icon="FileTextIcon" class="mb-3" />
            <b>Ürünler ve Stok Listesi</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('RequestList')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/PurchaseList')">
            <feather-icon icon="EyeIcon" class="mb-3" />
            <b>Talep Listesi</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('CostTracking')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/CostTracking')">
            <feather-icon icon="DollarSignIcon" class="mb-3" />
            <b>Maliyet İzleme</b>
          </div>
        </div>
      </vs-prompt>

      <!-- Muhasebe -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Account')" :vs-buttons-hidden="true" vs-title="Muhasebe" vs-button-cancel="border" :vs-active.sync="account">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('AccountMovement')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/AccountMovement')">
            <feather-icon icon="PauseCircleIcon" class="mb-3" />
            <b>Bekleyen Muhasebe Hareketleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('TransactedMovementWatch')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/TransactedMovementWatch')">
            <feather-icon icon="TargetIcon" class="mb-3" />
            <b>Fiş Bazlı İzleme</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('AccountMovementWatch')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/AccountMovementWatch')">
            <feather-icon icon="ActivityIcon" class="mb-3" />
            <b>Finansal Akış İzleme</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('MoneyTransfer')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/MoneyTransfer')">
            <feather-icon icon="DollarSignIcon" class="mb-3" />
            <b>Para Transferleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('AccountDashboard')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/AccountDashboard')">
            <feather-icon icon="FileTextIcon" class="mb-3" />
            <b>Nitro Mali Tablo</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('StatisticalDataDashboard')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/StatisticalDataDashboard')">
            <feather-icon icon="InfoIcon" class="mb-3" />
            <b>Nitro İstatistiki Bilgiler</b>
          </div>
        </div>
      </vs-prompt>
      <!-- CRM -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Crm')" :vs-buttons-hidden="true" vs-title="CRM" vs-button-cancel="border" :vs-active.sync="crm">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('VerimorRecordingTracking')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/crm')">
            <feather-icon icon="EyeIcon" class="mb-3" />
            <b>Verimor Kayıt İzleme</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('LastCalls')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/calls')">
            <feather-icon icon="PhoneIcon" class="mb-3" />
            <b>Son Çağrılar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('SendSms')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/CustomerCommentByUserId/' + $store.state.userData.userId)">
            <feather-icon icon="SendIcon" class="mb-3" />
            <b>Sms Gönder</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('CustomerComment')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/customerComment')">
            <feather-icon icon="MessageSquareIcon" class="mb-3" />
            <b>Müşteri Yorum Takibi</b>
          </div>
        </div>
      </vs-prompt>
      <!-- Gelir Gider -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('CustomerComment')" :vs-buttons-hidden="true" vs-title="Gelir Gider" vs-button-cancel="border" :vs-active.sync="expense">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('IncomeExpenseTransactions')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/expense')">
            <feather-icon icon="BarChart2Icon" class="mb-3" />
            <b>Gelir Gider İşlemleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Contacts')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/Contacts')">
            <feather-icon icon="UsersIcon" class="mb-3" />
            <b>Müşteriler</b>
          </div>
        </div>
      </vs-prompt>
      <!-- Depo -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Warehouse')" :vs-buttons-hidden="true" vs-title="Depo" vs-button-cancel="border" :vs-active.sync="warehouse">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('StockActions')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/StockActions')">
            <feather-icon icon="ActivityIcon" class="mb-3" />
            <b>Stok Aksiyonları</b>
          </div>
          <!-- <div class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/ProductTransact')">
            <feather-icon icon="LayersIcon" class="mb-3" />
            <b>Ürün İşlemleri</b>
          </div> -->
          <div v-if="CheckAuthorizationOfRouter('ProductPrice')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/productPrice')">
            <feather-icon icon="DollarSignIcon" class="mb-3" />
            <b>Ürün Fiyat</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('TransferTransactions')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/TransferTransact')">
            <feather-icon icon="TruckIcon" class="mb-3" />
            <b>Transfer İşlemleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('ProductControl')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/productControl')">
            <feather-icon icon="SearchIcon" class="mb-3" />
            <b>Ürün Kontrol</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('ReturnRequest')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/ReturnRequests')">
            <feather-icon icon="RewindIcon" class="mb-3" />
            <b>İade İşlemleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Products')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/Products')">
            <feather-icon icon="PackageIcon" class="mb-3" />
            <b>Ürünler</b>
          </div>
        </div>
      </vs-prompt>
      <!-- Teknik Servis Garaj -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('TechnicAndGarage')" :vs-buttons-hidden="true" vs-title="Teknik Servis, Garaj" vs-button-cancel="border" :vs-active.sync="technic">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('TechnicService')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/TechnicService')">
            <feather-icon icon="HardDriveIcon" class="mb-3" />
            <b>Teknik Servis</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Garage')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/Garage')">
            <feather-icon icon="TruckIcon" class="mb-3" />
            <b>Garaj</b>
          </div>
        </div>
      </vs-prompt>
      <!----Ticket----->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Ticket')" :vs-buttons-hidden="true" vs-title="Ticket" vs-button-cancel="border" :vs-active.sync="ticket">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('SupportTicket')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/SupportTicket')">
            <feather-icon icon="PhoneForwardedIcon" class="mb-3" />
            <b>Ticket</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('SupportTicketByUserId')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/SupportTicketByUserId/' + $store.state.userData.userId)">
            <feather-icon icon="PhoneIncomingIcon" class="mb-3" />
            <b>Açtığım Ticket</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('SupportTicketByAssignUserId')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/SupportTicketByAssignUserId/' + $store.state.userData.userId)">
            <feather-icon icon="PhoneOutgoingIcon" class="mb-3" />
            <b>Atanan Ticket</b>
          </div>
        </div>
      </vs-prompt>
      <!-----Projeler---->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Project')" :vs-buttons-hidden="true" vs-title="Projeler" vs-button-cancel="border" :vs-active.sync="project">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('HRProject')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/HRProject')">
            <feather-icon icon="FileTextIcon" class="mb-3" />
            <b>Projeler</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('HRProjectByAssignUserId')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/HRProjectByAssignUserId/' + $store.state.userData.userId)">
            <feather-icon icon="FilePlusIcon" class="mb-3" />
            <b>Görev Atanan Projeler</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('HRTimesheet')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/HRTimesheet')">
            <feather-icon icon="CalendarIcon" class="mb-3" />
            <b>Haftalık Plan</b>
          </div>
        </div>
      </vs-prompt>
      <!-- Yönetim -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('HumanResource')" :vs-buttons-hidden="true" vs-title="Yönetim" vs-button-cancel="border" :vs-active.sync="humanResource">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('UserList')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/userList')">
            <feather-icon icon="UserIcon" class="mb-3" />
            <b>Personel Listesi</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('AdvanceResource')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/advanceResource')">
            <feather-icon icon="DollarSignIcon" class="mb-3" />
            <b>Avans Talep Formu</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Permission')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/permission')">
            <feather-icon icon="FileTextIcon" class="mb-3" />
            <b>İzin Talep Formu</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Management')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/management')">
            <feather-icon icon="UserPlusIcon" class="mb-3" />
            <b>Personel Talep Yönetimi</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('OganizationalChart')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/organizationalchart')">
            <feather-icon icon="Share2Icon" class="mb-3" />
            <b>Organizasyon Şeması</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('HRShift')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/HRShift')">
            <feather-icon icon="ClockIcon" class="mb-3" />
            <b>Mesai Bilgileri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('PermissionList')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/PermissionList')">
            <feather-icon icon="BookOpenIcon" class="mb-3" />
            <b>Personel İzin Yönetimi</b>
          </div>
        </div>
      </vs-prompt>
      <!-----Parametrik Ekranlar----->
      <vs-prompt v-if="CheckAuthorizationOfRouter('ParametricScreens')" :vs-buttons-hidden="true" vs-title="Parametrik Ekranlar" vs-button-cancel="border" :vs-active.sync="parametric">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('Authorisation')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/authorisation')">
            <feather-icon icon="KeyIcon" class="mb-3" />
            <b>Yetkiler</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('UserAuthorisation')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/userAuthorisation')">
            <feather-icon icon="LockIcon" class="mb-3" />
            <b>Personel Yetkileri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Warehouses')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/warehouses')">
            <feather-icon icon="CodesandboxIcon" class="mb-3" />
            <b>Depolar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('UserWarehouse')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/warehouseUser')">
            <feather-icon icon="BoxIcon" class="mb-3" />
            <b>Personel Deposu</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Department')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/department')">
            <feather-icon icon="BriefcaseIcon" class="mb-3" />
            <b>Departmanlar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Title')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/title')">
            <feather-icon icon="BookOpenIcon" class="mb-3" />
            <b>Ünvanlar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Team')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/team')">
            <feather-icon icon="UsersIcon" class="mb-3" />
            <b>Takımlar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Tags')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/tags')">
            <feather-icon icon="TagIcon" class="mb-3" />
            <b>Etiketler</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('ProductBrand')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/productBrand')">
            <i style="font-size: 30px;" class="mb-3 material-icons-outlined">branding_watermark</i>
            <b>Markalar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('ProductCategory')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/productCategory')">
            <i style="font-size: 30px;" class="mb-3 material-icons-outlined">category</i>
            <b>Kategoriler</b>
          </div>
          <!-- <div v-if="CheckAuthorizationOfRouter('AccountCompanyType')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/accountCompanyType')">
            <i style="font-size: 30px;" class="mb-3 material-icons-outlined">currency_lira</i>
            <b>Harcama Türleri</b>
          </div> -->
          <div v-if="CheckAuthorizationOfRouter('AccountMovementUpdate')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/accountMovementUpdate')">
            <feather-icon icon="DollarSignIcon" class="mb-3" />
            <b>Hesap Hareket İşlemleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('ProductManifactureType')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/productManifactureType')">
            <feather-icon icon="BatteryIcon" class="mb-3" />
            <b>Üretim Tür İşlemleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('InventoryStockType')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/inventoryStockType')">
            <feather-icon icon="ScissorsIcon" class="mb-3" />
            <b>Envanter Tür İşlemleri</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('DynamicMenu')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/dynamicMenu')">
            <feather-icon icon="SettingsIcon" class="mb-3" />
            <b>Dinamik Menü</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('Router')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/router')">
            <feather-icon icon="ExternalLinkIcon" class="mb-3" />
            <b>Routerlar</b>
          </div>
          <!-- <div v-if="CheckAuthorizationOfRouter('RouterUser')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/routerUser')">
            <feather-icon icon="LinkIcon" class="mb-3" />
            <b>Personel Routerları</b>
          </div> -->
          <div v-if="CheckAuthorizationOfRouter('RouterDefaultUserType')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/routerDefaultUserType')">
            <feather-icon icon="DatabaseIcon" class="mb-3" />
            <b>Kullanıcı Türüne Göre Routerlar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('x')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/dailyCurrencies')">
            <i style="font-size: 30px;" class="mb-3 material-icons-outlined">monetization_on</i>
            <b>Günlük Kurlar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('x')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/saleUpdate')">
            <feather-icon icon="EditIcon" class="mb-3" />
            <b>Satış Güncelleme</b>
          </div>
        </div>
      </vs-prompt>
      <!-- arge -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Arge')" :vs-buttons-hidden="true" vs-title="arge" vs-button-cancel="border" :vs-active.sync="arge">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('ObdTalkParam')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/obdTalkParam')">
            <span class="custom-icon mb-3">
              <svg version="1.1" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background: new 0 0 24 24;" xml:space="preserve">
                <g>
                  <path
                    d="M22.3,7.2c-0.2-0.1-0.5-0.1-0.7-0.1H2.2C1.1,7.2,0.4,8.5,0.8,9.5L3,15.7c0.2,0.5,0.6,0.8,1.1,0.8h5.4c0,0,0.1,0,0.1,0
		l0.3,0.3c0,0,0.1,0.1,0.2,0.1h3.9c0.1,0,0.1,0,0.2-0.1l0.3-0.3c0,0,0.1,0,0.1,0h5.3c0.5,0,0.9-0.3,1.1-0.8l2.3-6.2
		C23.5,8.6,23.1,7.6,22.3,7.2z M7.5,13.2c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.3,0-0.7,0-1-0.1
		c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.2-0.1-0.5,0-0.8c0.1-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.6-0.6,1-0.8
		C5.6,9.7,6,9.6,6.5,9.6c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0,0.8
		c-0.1,0.3-0.2,0.6-0.3,0.9C8,12.8,7.8,13,7.5,13.2z M11.3,13.5c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.6,0c-0.3,0-0.6,0-0.9,0
		l-0.8,0l-0.6,0c0.1-0.4,0.2-0.8,0.3-1c0.1-0.3,0.2-0.8,0.3-1.4c0.1-0.6,0.2-1,0.2-1.3c0-0.1,0-0.2,0.1-0.4c0.3,0,0.5,0,0.6,0
		c0.2,0,0.5,0,0.8,0c0.3,0,0.5,0,0.8,0c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.4,0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3
		c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.1
		c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3
		c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.3C11.5,13.4,11.4,13.5,11.3,13.5z M15.1,13.4
		c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0-0.3,0.1-0.5,0.1c-0.2,0-0.5,0-0.8,0l-1.2,0c-0.1,0-0.3,0-0.6,0c0.1-0.5,0.2-0.8,0.3-1.1
		c0.1-0.4,0.2-0.9,0.4-1.6c0.1-0.5,0.2-0.8,0.2-1l0.1-0.3c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.7,0c0.3,0,0.5,0,0.8,0c0.3,0,0.5,0,0.7,0
		c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.2,0.3,0.2,0.6c0,0.2,0,0.4,0,0.7c0,0.2-0.1,0.4-0.2,0.6
		c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.3-0.4,0.4C15.4,13.2,15.3,13.3,15.1,13.4z M19.9,10.5c0,0.1,0,0.2-0.1,0.3
		c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.7,0.6c-0.2,0.2-0.5,0.4-0.9,0.7h0.8c0.2,0,0.4,0,0.5,0
		c0.1,0,0.2,0,0.3,0c0,0.1,0,0.2-0.1,0.4c0,0.1-0.1,0.3-0.1,0.5c-0.5,0-1,0-1.6,0c-0.7,0-1.2,0-1.7,0c0-0.1,0.1-0.2,0.1-0.4
		c0-0.2,0.1-0.3,0.1-0.5c0.2-0.2,0.5-0.3,0.7-0.5c0.3-0.3,0.6-0.5,0.9-0.7c0.2-0.2,0.4-0.3,0.5-0.5c0.1-0.1,0.1-0.2,0.2-0.2
		c0,0,0-0.1,0.1-0.1c0-0.1,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.5,0
		c-0.1,0-0.4,0.1-0.7,0.1l0.2-0.4c0-0.1,0.1-0.2,0.2-0.5c0.5-0.1,1-0.1,1.5-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0,0.3,0.1,0.5,0.2
		c0.1,0.1,0.2,0.2,0.3,0.3C19.9,10.2,19.9,10.4,19.9,10.5z"
                  />
                  <path
                    d="M7.2,11.6c0,0.2-0.1,0.4-0.3,0.6c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0-0.6-0.1
		c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.1-0.4,0-0.6c0-0.2,0.1-0.4,0.3-0.6c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.7-0.2
		c0.2,0,0.4,0,0.6,0.1C7,10.7,7.1,10.8,7.2,11C7.2,11.2,7.3,11.4,7.2,11.6z"
                  />
                  <path
                    d="M11,10.8c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0H9.8
		l0.2-0.8h0.5c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0.1,0.1,0.1C11,10.7,11.1,10.7,11,10.8z"
                  />
                  <path
                    d="M10.8,12.2c0,0,0,0.1,0,0.2s0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3,0H9.4L9.6,12h0.6
		c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0.1C10.8,12.1,10.8,12.2,10.8,12.2z"
                  />
                  <path
                    d="M15.1,11.5c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.3-0.4,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4,0-0.6,0
		c-0.1,0-0.2,0-0.3,0l0.5-2.3c0.2,0,0.4,0,0.5,0c0.2,0,0.4,0,0.6,0.1c0.1,0.1,0.2,0.2,0.3,0.3C15.2,11.1,15.2,11.3,15.1,11.5z"
                  />
                </g>
              </svg>
            </span>
            <b>Obd2Talk Veri İşlem</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('ObdTalkParamV2')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/obdTalkParamV2')">
            <span class="custom-icon mb-3">
              <svg version="1.1" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background: new 0 0 24 24;" xml:space="preserve">
                <g>
                  <path
                    d="M22.3,7.2c-0.2-0.1-0.5-0.1-0.7-0.1H2.2C1.1,7.2,0.4,8.5,0.8,9.5L3,15.7c0.2,0.5,0.6,0.8,1.1,0.8h5.4c0,0,0.1,0,0.1,0
		l0.3,0.3c0,0,0.1,0.1,0.2,0.1h3.9c0.1,0,0.1,0,0.2-0.1l0.3-0.3c0,0,0.1,0,0.1,0h5.3c0.5,0,0.9-0.3,1.1-0.8l2.3-6.2
		C23.5,8.6,23.1,7.6,22.3,7.2z M7.5,13.2c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.3,0-0.7,0-1-0.1
		c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.2-0.1-0.5,0-0.8c0.1-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.6-0.6,1-0.8
		C5.6,9.7,6,9.6,6.5,9.6c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0,0.8
		c-0.1,0.3-0.2,0.6-0.3,0.9C8,12.8,7.8,13,7.5,13.2z M11.3,13.5c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.6,0c-0.3,0-0.6,0-0.9,0
		l-0.8,0l-0.6,0c0.1-0.4,0.2-0.8,0.3-1c0.1-0.3,0.2-0.8,0.3-1.4c0.1-0.6,0.2-1,0.2-1.3c0-0.1,0-0.2,0.1-0.4c0.3,0,0.5,0,0.6,0
		c0.2,0,0.5,0,0.8,0c0.3,0,0.5,0,0.8,0c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.4,0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3
		c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.1
		c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3
		c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.3C11.5,13.4,11.4,13.5,11.3,13.5z M15.1,13.4
		c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0-0.3,0.1-0.5,0.1c-0.2,0-0.5,0-0.8,0l-1.2,0c-0.1,0-0.3,0-0.6,0c0.1-0.5,0.2-0.8,0.3-1.1
		c0.1-0.4,0.2-0.9,0.4-1.6c0.1-0.5,0.2-0.8,0.2-1l0.1-0.3c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.7,0c0.3,0,0.5,0,0.8,0c0.3,0,0.5,0,0.7,0
		c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.2,0.3,0.2,0.6c0,0.2,0,0.4,0,0.7c0,0.2-0.1,0.4-0.2,0.6
		c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.3-0.4,0.4C15.4,13.2,15.3,13.3,15.1,13.4z M19.9,10.5c0,0.1,0,0.2-0.1,0.3
		c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.7,0.6c-0.2,0.2-0.5,0.4-0.9,0.7h0.8c0.2,0,0.4,0,0.5,0
		c0.1,0,0.2,0,0.3,0c0,0.1,0,0.2-0.1,0.4c0,0.1-0.1,0.3-0.1,0.5c-0.5,0-1,0-1.6,0c-0.7,0-1.2,0-1.7,0c0-0.1,0.1-0.2,0.1-0.4
		c0-0.2,0.1-0.3,0.1-0.5c0.2-0.2,0.5-0.3,0.7-0.5c0.3-0.3,0.6-0.5,0.9-0.7c0.2-0.2,0.4-0.3,0.5-0.5c0.1-0.1,0.1-0.2,0.2-0.2
		c0,0,0-0.1,0.1-0.1c0-0.1,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.5,0
		c-0.1,0-0.4,0.1-0.7,0.1l0.2-0.4c0-0.1,0.1-0.2,0.2-0.5c0.5-0.1,1-0.1,1.5-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0,0.3,0.1,0.5,0.2
		c0.1,0.1,0.2,0.2,0.3,0.3C19.9,10.2,19.9,10.4,19.9,10.5z"
                  />
                  <path
                    d="M7.2,11.6c0,0.2-0.1,0.4-0.3,0.6c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0-0.6-0.1
		c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.1-0.4,0-0.6c0-0.2,0.1-0.4,0.3-0.6c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.7-0.2
		c0.2,0,0.4,0,0.6,0.1C7,10.7,7.1,10.8,7.2,11C7.2,11.2,7.3,11.4,7.2,11.6z"
                  />
                  <path
                    d="M11,10.8c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0H9.8
		l0.2-0.8h0.5c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0.1,0.1,0.1C11,10.7,11.1,10.7,11,10.8z"
                  />
                  <path
                    d="M10.8,12.2c0,0,0,0.1,0,0.2s0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3,0H9.4L9.6,12h0.6
		c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0.1C10.8,12.1,10.8,12.2,10.8,12.2z"
                  />
                  <path
                    d="M15.1,11.5c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.3-0.4,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4,0-0.6,0
		c-0.1,0-0.2,0-0.3,0l0.5-2.3c0.2,0,0.4,0,0.5,0c0.2,0,0.4,0,0.6,0.1c0.1,0.1,0.2,0.2,0.3,0.3C15.2,11.1,15.2,11.3,15.1,11.5z"
                  />
                </g>
              </svg>
            </span>
            <b>Obd2Talk Veri İşlem V2</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('x')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/Subscriptions')">
            <feather-icon icon="ListIcon" class="mb-3" />
            <b>Abonelikleri Listele</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('CarCanbusData')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/CarCanbusData')">
            <feather-icon icon="SquareIcon" class="mb-3" />
            <b>Anlık Canbus Data Okuma</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('FirmwareUpdate')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/FirmwareUpdate')">
            <feather-icon icon="CopyIcon" class="mb-3" />
            <b>Firmware Güncelleme</b>
          </div>
        </div>
      </vs-prompt>
      <!-- Otomatik İşlemler -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('AutomaticOperation')" :vs-buttons-hidden="true" vs-title="Otomatik İşlemler" vs-button-cancel="border" :vs-active.sync="automatic">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('AutomaticOperationRun')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/AutomaticOperation')">
            <feather-icon icon="FeatherIcon" class="mb-3" />
            <b>Otomatik İşlem Çalıştırma</b>
          </div>
        </div>
      </vs-prompt>
      <!-- Raporlama -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Reports')" :vs-buttons-hidden="true" vs-title="Raporlama" vs-button-cancel="border" :vs-active.sync="reports">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('PersonnelReport')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/Reports')">
            <feather-icon icon="UserIcon" class="mb-3" />
            <b>Personel Raporları</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('CustomerReport')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/customerReports')">
            <feather-icon icon="ClipboardIcon" class="mb-3" />
            <b>Müşteri Raporları</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('SummaryReport')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/summaryReports')">
            <feather-icon icon="TrelloIcon" class="mb-3" />
            <b>Özet Raporlar</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('TechnicReport')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/technicReports')">
            <feather-icon icon="AlignJustifyIcon" class="mb-3" />
            <b>Teknik, Garaj Raporları</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('SupportTicketReport')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/SupportTicketReport')">
            <feather-icon icon="HelpCircleIcon" class="mb-3" />
            <b>Support Ticket Raporu</b>
          </div>
        </div>
      </vs-prompt>
      <!-- Demirbaş ve Zimmet Yönetimi -->
      <vs-prompt v-if="CheckAuthorizationOfRouter('Inventory')" :vs-buttons-hidden="true" vs-title="Demirbaş ve Zimmet Menüsü" vs-button-cancel="border" :vs-active.sync="inventoryStockMenu">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('InventoryStock')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/InventoryStock')">
            <feather-icon icon="ScissorsIcon" class="mb-3" />
            <b>Zimmet İşlemler</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('InventoryStockList')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/InventoryStockList')">
            <feather-icon icon="ScissorsIcon" class="mb-3" />
            <b>Zimmet Listesi</b>
          </div>
        </div>
      </vs-prompt>
      <vs-prompt v-if="CheckAuthorizationOfRouter('x')" :vs-buttons-hidden="true" vs-title="Üretim" vs-button-cancel="border" :vs-active.sync="production">
        <div class="popup-grid">
          <div v-if="CheckAuthorizationOfRouter('x')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/ProductionWizard')">
            <i style="font-size: 30px;" class="mb-3 material-icons-outlined">loupe</i>
            <b>Üretim Oluşturma</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('x')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/ProductionList')">
            <i style="font-size: 30px;" class="mb-3 material-icons-outlined">list_alt</i>
            <b>Üretim Listesi</b>
          </div>
          <div v-if="CheckAuthorizationOfRouter('ProductionReceiptChart')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="openLink('/ProductionReceipt')">
            <feather-icon icon="SlidersIcon" class="mb-3" />
            <b>Reçete Hazırlama</b>
          </div>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      sales: false,
      purchase: false,
      account: false,
      crm: false,
      expense: false,
      warehouse: false,
      technic: false,
      ticket: false,
      project: false,
      humanResource: false,
      parametric: false,
      arge: false,
      automatic: false,
      reports: false,
      inventoryStockMenu: false,
      production: false,
    };
  },
  methods: {
    MenuVisible(item) {},
    salesPopup() {
      this.sales = true;
    },
    purchasePopup() {
      this.purchase = true;
    },
    openLink(link) {
      this.$router.push(link).catch((err) => {});
    },
    closePopupLink: async function () {
      if (this.sales) this.sales = false;
      if (this.purchase) this.purchase = false;
      if (this.account) this.account = false;
      if (this.crm) this.crm = false;
      if (this.expense) this.expense = false;
      if (this.warehouse) this.warehouse = false;
      if (this.technic) this.technic = false;
      if (this.ticket) this.ticket = false;
      if (this.project) this.project = false;
      if (this.humanResource) this.humanResource = false;
      if (this.parametric) this.parametric = false;
      if (this.arge) this.arge = false;
      if (this.automatic) this.automatic = false;
      if (this.reports) this.reports = false;
      if (this.inventoryStockMenu) this.inventoryStockMenu = false;
      if (this.production) this.production = false;
    },
    accountPopup() {
      this.account = true;
    },
    crmPopup() {
      this.crm = true;
    },
    expensePopup() {
      this.expense = true;
    },
    warehousePopup() {
      this.warehouse = true;
    },
    technicPopup() {
      this.technic = true;
    },
    ticketPopup() {
      this.ticket = true;
    },
    projectPopup() {
      this.project = true;
    },
    humanResourcePopup() {
      this.humanResource = true;
    },
    parametricPopup() {
      this.parametric = true;
      console.log("yetki");
    },
    argePopup() {
      this.arge = true;
    },
    automaticPopup() {
      this.automatic = true;
    },
    reportsPopup() {
      this.reports = true;
    },
    productionPopup() {
      this.production = true;
    },
    cancel() {},
    close() {},
  },

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.closePopupLink();
      }
    });
  },

  beforeRouteLeave: async function (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    // this.satis = false;
    // this.satinAlma = false;
    // this.muhasebe = false;
    // this.crm = false;
    // this.gelirGider = false;
    // this.depo = false;
    // this.teknikServis = false;
    // this.ticket = false;
    // this.project = false;
    // this.yonetim = false;
    // this.parametric = false;
    // this.arge = false;
    // this.otoIslem = false;
    // this.raporlama = false;

    await this.closePopupLink();
    next();
  },
};
</script>
